import { render } from "./checkbox.vue?vue&type=template&id=a0465be8&scoped=true"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import "./checkbox.vue?vue&type=style&index=0&id=a0465be8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0465be8"],['__file',"src/views/vab/form/checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0465be8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0465be8', __exports__)) {
    console.log('reload')
    api.reload('a0465be8', __exports__)
  }
  
  module.hot.accept("./checkbox.vue?vue&type=template&id=a0465be8&scoped=true", () => {
    console.log('re-render')
    api.rerender('a0465be8', render)
  })

}


export default __exports__